import React from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { FiTool } from "react-icons/fi";

const CustomerEnquiry = () => {
    return (
        <Container className="py-5">
            <Row className="justify-content-center align-items-center min-vh-50">
                <Col md={6} className="text-center">

                    <div className="mb-4">
                        <FiTool size={25} className="text-muted" />
                    </div>

                    <Alert variant="info" className="text-center">
                        <h4 className="alert-heading">Page Under Development</h4>
                        <p>
                            This feature is currently being developed and will be available soon.
                            Thank you for your patience.
                        </p>
                    </Alert>
                </Col>
            </Row>
        </Container>
    );
};

export default CustomerEnquiry;